import { AddShareDto } from './AddShareDto'

export class ModifyShareDto extends AddShareDto {}
